<template>
  <div class="hot-team-goal-place">
    <div class="plate-title">
      <span><img src="../../assets/svg/hot-team-goal-place.svg" /></span>
      <p>春生夏长秋收冬藏，一年四季带您看最美的风景，做最赞的团建。</p>
    </div>
    <div class="card-content-out">
      <div class="card-content" v-if="destinationList">
        <el-row :gutter="20">
          <el-col :span="12">
            <div
              class="card-content-item2 card-content-item"
              v-on:mouseover="showPicTxt(1)"
              v-on:mouseleave="hidePicTxt()"
              @click="goTeambuildList(destinationList[0].id)"
            >
              <div>
                <div class="background-pic img0" :style="{backgroundImage: 'url('+'\'' + destinationList[0].horizontalImage +'\''+ ')'}"></div>
                <div class="large-title-div">
                  <p class="large-title">{{destinationList[0].name}}</p>
                </div>
              </div>
              <div class="mask" v-if="isShowPicTxt == 1">
                <p class="mask-title">古北水镇</p>
                <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                <p class="mask-subtitle">
                  泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div
              class="card-content-item1 card-content-item"
              style="margin-bottom: 21px"
              v-on:mouseover="showPicTxt(2)"
              v-on:mouseleave="hidePicTxt()"
              @click="goTeambuildList(destinationList[1].id)"
            >
              <div>
                <div class="background-pic2 img1" :style="{backgroundImage: 'url('+'\'' + destinationList[1].image +'\''+ ')'}"></div>
                <div class="large-title-div">
                  <p class="large-title">{{destinationList[1].name}}</p>
                </div>
                <div class="mask2" v-if="isShowPicTxt == 2">
                  <p class="mask-title">古北水镇</p>
                  <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                  <p class="mask-subtitle">
                    泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                  </p>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="card-content-item1 card-content-item"
                  v-on:mouseover="showPicTxt(3)"
                  v-on:mouseleave="hidePicTxt()"
                  @click="goTeambuildList(destinationList[2].id)">
              <div>
              <div class="background-pic2 img2" :style="{backgroundImage: 'url(' +'\''+ destinationList[2].image +'\''+ ')'}"></div>
              <div class="large-title-div">
                <p class="large-title">{{destinationList[2].name}}</p>
              </div>
              </div>
              <div class="mask2" v-if="isShowPicTxt == 3">
                <p class="mask-title">古北水镇</p>
                <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                <p class="mask-subtitle">
                  泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                </p>
              </div>
            </div></el-col>
        </el-row>
        <el-row :gutter="20" class="layout-bottom">
          <el-col :span="6">
            <div
              class="card-content-item1 card-content-item"
              style="margin-bottom: 21px"
              v-on:mouseover="showPicTxt(4)"
              v-on:mouseleave="hidePicTxt()"
              @click="goTeambuildList(destinationList[3].id)">
              <div>
              <div class="background-pic2 img3" :style="{backgroundImage: 'url('+'\'' + destinationList[3].image+'\'' + ')'}"></div>
              <div class="large-title-div">
                <p class="large-title">{{destinationList[3].name}}</p>
              </div>
              </div>
              <div class="mask2" v-if="isShowPicTxt == 4">
                <p class="mask-title">古北水镇</p>
                <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                <p class="mask-subtitle">
                  泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="card-content-item1 card-content-item"
              v-on:mouseover="showPicTxt(5)"
              v-on:mouseleave="hidePicTxt()"
              @click="goTeambuildList(destinationList[4].id)">
              <div>
              <div class="background-pic2 img4" :style="{backgroundImage: 'url('+'\'' + destinationList[4].image +'\''+ ')'}"></div>
              <div class="large-title-div">
                <p class="large-title">{{destinationList[4].name}}</p>
              </div>
              </div>
              <div class="mask2" v-if="isShowPicTxt == 5">
                <p class="mask-title">古北水镇</p>
                <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                <p class="mask-subtitle">
                  泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                </p>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div
              class="card-content-item2 card-content-item"
              style="margin-top: 80px"
              v-on:mouseover="showPicTxt(6)"
              v-on:mouseleave="hidePicTxt()"
              @click="goTeambuildList(destinationList[5].id)"
            >
              <div>
                <div class="background-pic img5" :style="{backgroundImage: 'url('+'\'' + destinationList[5].horizontalImage+'\'' + ')'}"></div>
                <div class="large-title-div">
                  <p class="large-title">{{destinationList[5].name}}</p>
                </div>
                <div class="mask" v-if="isShowPicTxt == 6">
                  <p class="mask-title">古北水镇</p>
                  <p class="mask-subtitles">古镇 | 温泉 | 长城</p>
                  <p class="mask-subtitle">
                    泡温泉，品美食，逛古镇，玩转长城下的温泉小镇
                  </p>
                </div>
              </div>
              <div v-if="isShowPicTxt == 1"></div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { handlePicPlusPre } from "../../util/util";
export default {
  name: "adDetails",
  components: {},
  props: {},
  data() {
    return {
      id: null,
      message: null,
      //
      isShowPicTxt: 0,
      destinationList:[
        {id:'',name:'',image:''},
        {id:'',name:'',image:''},
        {id:'',name:'',image:''},
        {id:'',name:'',image:''},
        {id:'',name:'',image:''},
        {id:'',name:'',image:''},
      ],
    };
  },
  watch: {},
  computed: {
    getScrolltop() {
      let _this = this;
      window.addEventListener("scroll", () => {
        _this.top =
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.pageYOffset;
      });
      return _this.top > 300;
    },
    getLocationSiteCityId(){
      return this.$store.state.locationSiteCity;
    },
  },
  methods: {
    handlePicPlusPre,
    showPicTxt(index) {
      // this.isShowPicTxt = index;
    },
    hidePicTxt() {
      // this.isShowPicTxt = 0;
    },
    // 去团建页面
    goTeambuildList(id){
        this.$router.push({ path: `/teamBuilding`, query: { destinationId: id } });
    },
    // 查询行政区
    getDestinationList() {
      let cityId = this.getLocationSiteCityId;
      let params = {
        cityId: this.getLocationSiteCityId,
      };
      axios
        .get(`/api/city/destinationList`, {
          params,
        })
        .then((res) => {
          if (res.data && res.data.code == 200) {
            this.destinationList = res.data.destinationList;
            if (this.destinationList) {
              this.destinationList.forEach((destination) => {
                if (destination.image) {
                  destination.image = handlePicPlusPre(destination.image);
                  destination.horizontalImage = handlePicPlusPre(destination.horizontalImage);
                  destination.image = destination.image[0];
                  destination.horizontalImage = destination.horizontalImage[0];
                }
                if(this.destinationList.length<6){
                  for (let index = 0; index < 6; index++) {
                    let destination = {
                      id:'',
                      name:'',
                      image:''
                    }
                    this.destinationList.push(destination);
                  }
                }
              });
            }
            console.log("--destinationList---");
            console.log(this.destinationList);
          }
        });
    },
  },
  created() {},
  mounted() {
    this.getDestinationList()
  },
};
</script>
<style scoped>
.hot-team-goal-place .plate-title {
  min-height: 160px;
}
.hot-team-goal-place .plate-title span {
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 38px;
  color: #201f1f;
  padding-top: 50px;
}
.hot-team-goal-place .plate-title p {
  display: inline-block;
  text-align: center;
  width: 100%;
  font-size: 18px;
  color: #666;
  padding-top: 20px;
  padding-bottom: 40px;
}
.card-content-out {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
}
.hot-team-goal-place .card-content {
  width: 1060px;
  /* display: flex;
  flex-direction: row;
  justify-content: center; */
}
.hot-team-goal-place .card-content .card-content-item2 {
  height: 300px;
  /* background-color: #ff0000; */
}
.hot-team-goal-place .card-content .card-content-item1 {
  height: 380px;
  /* background-color: #ffff00; */
}
.hot-team-goal-place .layout-bottom {
  position: relative;
  top: -80px;
}
.hot-team-goal-place .card-content-item {
  border-radius: 6px;
  cursor: pointer;
}
.card-content div .background-pic {
  width: 100%;
  height: 300px;
  border-radius: 6px;
  background-size: cover;
  /* background-image: url(https://imetadata.damaotuanjian.com/METADATA/FE9CE190-9F5A-11EC-B125-633357C0BCDB.jpg); */
}
.card-content-item>div:hover{
    transform: scale(1.1);

  /* background-image: url(https://imetadata.damaotuanjian.com/METADATA/FE9CE190-9F5A-11EC-B125-633357C0BCDB.jpg); */
}
.card-content-item>div{
    transition-property: all;
    transition-duration: 0.5s;
    transition-timing-function: ease;
    transition-delay: 0s;
}
.card-content div .background-pic2 {
  width: 100%;
  height: 380px;
  border-radius: 6px;
  background-size: cover;
  /* background-image: url(https://imetadata.damaotuanjian.com/METADATA/FE9CE190-9F5A-11EC-B125-633357C0BCDB.jpg); */
}
.card-content div .img0{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img0)
}
.card-content div .img1{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img1)
}
.card-content div .img2{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img2)
}
.card-content div .img3{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img3)
}
.card-content div .img4{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img4)
}
.card-content div .img5{
  /* width: 100%;
  height: 380px;
  border-radius: 6px; */
  background-image: var(--img5)
}
.card-content div .large-title-div {
  font-size: 28px;
  color: #fff;
  line-height: 77px;
  text-align: center;
  display: inline-block;
  width: 100%;
  text-shadow: 0 2px 1px rgb(0 0 0 / 30%);
  border-radius: 6px;
}
.card-content div .large-title-div {
  background-image: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.58));
  height: 77px;
  position: relative;
  left: 0;
  right: 0;
  bottom: 76px;
}
.card-content .mask {
  transition: all 0.3s ease-in-out;
  background: #359ff8;
  opacity: 0.9;
  position: relative;
  left: 0;
  top: -380px;
  width: 100%;
  height: 205px;
  padding: 50px 0;
  text-align: center;
  border-radius: 6px;
}
.card-content .mask2 {
  transition: all 0.3s ease-in-out;
  background: #359ff8;
  opacity: 0.9;
  position: relative;
  left: 0;
  top: -460px;
  width: 100%;
  height: 285px;
  padding: 50px 0;
  text-align: center;
  border-radius: 6px;
}
.card-content .mask-title {
  font-size: 28px;
  font-weight: 700;
  color: #222;
}

.card-content .mask-subtitles {
  font-size: 16px;
  font-weight: 700;
  padding: 10px 0;
  color: #222;
}

.card-content .mask-subtitle {
  font-size: 14px;
  color: #222;
  padding: 6px 15%;
}
</style>


// WEBPACK FOOTER //
// src/components/home/hotTeamGoalPlace.vue